module.exports = __webpack_public_path__ + "assets/fonts/Gotham-Thin.4f47f6ef.otf";